export type AccessTokenClaims = Record<string, unknown> & {
	roles?: string[];
};

export const decodeJwt = (token: string | null): AccessTokenClaims | null => {
	if (!token || typeof globalThis.atob !== 'function') {
		return null;
	}

	const [, payload] = token.split('.');

	if (!payload) {
		return null;
	}

	try {
		const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
		const paddedBase64 = base64.padEnd(
			base64.length + ((4 - (base64.length % 4 || 4)) % 4),
			'=',
		);
		const binaryPayload = globalThis.atob(paddedBase64);
		const payloadBytes = Uint8Array.from(binaryPayload, (char) => {
			return char.charCodeAt(0);
		});
		const decodedPayload = new TextDecoder().decode(payloadBytes);

		return JSON.parse(decodedPayload) as AccessTokenClaims;
	} catch {
		return null;
	}
};

export const getRolesFromClaims = (claims: AccessTokenClaims | null): string[] => {
	if (!claims || !Array.isArray(claims.roles)) {
		return [];
	}

	return claims.roles.filter((role): role is string => {
		return typeof role === 'string';
	});
};
